export default function Footer() {
    return (
      <footer className="mt-16 border-t border-neutral-200 bg-white">
        <div className="container py-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-neutral-900 font-semibold">Sri Venkateswara Degree & PG College</h4>
              <p className="mt-2 text-sm text-neutral-600">Nellore, Andhra Pradesh</p>
              <p className="mt-1 text-sm text-neutral-600">CAM High School Road</p>
            </div>
            <div>
              <h4 className="text-neutral-900 font-semibold">Contact</h4>
              <p className="mt-2 text-sm text-neutral-600">Phone: +91-9390332035</p>
              <p className="mt-1 text-sm text-neutral-600">Email: srivenkateswara148@gmail.com</p>
            </div>
            <div>
              <h4 className="text-neutral-900 font-semibold">Quick Links</h4>
              <ul className="mt-2 space-y-1 text-sm">
                <li><a href="/about" className="hover:text-primary-700">About</a></li>
                <li><a href="/academics" className="hover:text-primary-700">Academics</a></li>
                <li><a href="/facilities" className="hover:text-primary-700">Facilities</a></li>
                <li><a href="/gallery" className="hover:text-primary-700">Gallery</a></li>
                <li><a href="/contact" className="hover:text-primary-700">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-neutral-200 text-sm text-neutral-600 flex flex-col md:flex-row items-center justify-between">
            <p>© 2025 Sri Venkateswara Degree & PG College, Nellore</p>
          </div>
        </div>
      </footer>
    );
}
  